function pad(n) {
  return n < 10 ? "0" + n : n;
}

export function localISODateString(date) {
  if (!date) {
    return null;
  }

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}`;
}

export function documentDateFormat(date, includeTime = true) {
  if (!date) {
    return null;
  }

  let dateTime = [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate())
  ].join("-");
  if (includeTime) {
    const time = [
      pad(date.getHours()),
      pad(date.getMinutes()),
      pad(date.getSeconds())
    ].join(":");
    dateTime = `${dateTime}, ${time}`;
  }
  return dateTime;
}

export function getDateBeforeTomorrow(date) {
  const currentDate = new Date();

  if (date && new Date(date) < currentDate) {
    return date;
  }

  return localISODateString(currentDate);
}

export function calculateAgeFromDateOfBirth(dob) {
  const dateOfBirth = new Date(dob);
  const diffMs = Date.now() - dateOfBirth.getTime();
  const date = new Date(diffMs);

  return Math.abs(date.getUTCFullYear() - 1970);
}
